/**
 * Helper functions for managing portal URL parameters
 */

export interface PortalParams {
  userId?: string;
  therapistId?: string;
  type?: string;
}

/**
 * Builds a URLSearchParams object from portal parameters
 */
export function buildPortalParams(params: PortalParams): URLSearchParams {
  const urlParams = new URLSearchParams();

  if (params.userId) {
    urlParams.set("userId", params.userId);
  }
  if (params.therapistId) {
    urlParams.set("therapistId", params.therapistId);
  }
  if (params.type) {
    urlParams.set("type", params.type);
  }

  return urlParams;
}

/**
 * Determines the appropriate redirect URL based on portal parameters
 */
export function getPortalRedirectUrl(
  params: PortalParams,
  fromScheduleRoute: boolean = false,
): string {
  // Redirect to schedule page if:
  // 1. user was on /portal/schedule route, OR
  // 2. therapistId or type parameters are present (indicating scheduling context)
  const shouldRedirectToSchedule =
    fromScheduleRoute || params.therapistId || params.type;
  const baseUrl = shouldRedirectToSchedule
    ? "/portal/schedule"
    : "/portal/appointments";
  const urlParams = buildPortalParams(params);

  return urlParams.toString() ? `${baseUrl}?${urlParams.toString()}` : baseUrl;
}

/**
 * Builds a login URL with portal parameters
 */
export function getPortalLoginUrl(params: PortalParams): string {
  const urlParams = buildPortalParams(params);
  return urlParams.toString()
    ? `/portal/login?${urlParams.toString()}`
    : "/portal/login";
}
